import { gql } from '@apollo/client';

const GET_COURT_CASES_PAGED = gql`
    query courtCasesPaged($filters: CourtCaseFilters!, $first: Int, $after: String) {
        courtCasesPaged(filters: $filters, first: $first, after: $after) {
            pageInfo {
                hasNextPage
                endCursor
            }
            edges {
                node {
                    id
                    caseForms {
                        id
                        version
                        status
                    }
                    docket
                    name
                    court {
                        id
                        name
                    }
                    administrativeLevel1 {
                        id
                        name
                    }
                    commodities {
                        id
                        species {
                            commonName
                        }
                        unit
                    }
                    startDate
                    endDate
                    caseDurationDays
                    isConcluded
                    isConviction
                    defenseAttorneyCount
                    firstEvent {
                        id
                        date
                        stage
                    }
                    latestEvent {
                        id
                        date
                        stage
                    }
                }
            }
        }
    }
`;

export default GET_COURT_CASES_PAGED;
